// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pcpG","type":"styles_type__2HXPQ","choices":"styles_choices__1nV5e"};